__turbopack_context__.v({
  "card": "RecipePairingsCard-module-scss-module__O2kexG__card",
  "content": "RecipePairingsCard-module-scss-module__O2kexG__content",
  "description": "RecipePairingsCard-module-scss-module__O2kexG__description",
  "image": "RecipePairingsCard-module-scss-module__O2kexG__image",
  "image-wrap": "RecipePairingsCard-module-scss-module__O2kexG__image-wrap",
  "times": "RecipePairingsCard-module-scss-module__O2kexG__times",
  "title": "RecipePairingsCard-module-scss-module__O2kexG__title",
});
